
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b8EMT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $31fc0b63559b10c1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $k8MAo = parcelRequire("k8MAo");

var $7Clnv = parcelRequire("7Clnv");

var $gKURT = parcelRequire("gKURT");

var $gs2u7 = parcelRequire("gs2u7");

var $9b70D = parcelRequire("9b70D");

var $2aGBJ = parcelRequire("2aGBJ");

var $4rBM8 = parcelRequire("4rBM8");

var $gx7I6 = parcelRequire("gx7I6");

var $4tmE5 = parcelRequire("4tmE5");

var $k3QGO = parcelRequire("k3QGO");

var $68WXR = parcelRequire("68WXR");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $6KORI = parcelRequire("6KORI");

var $7D2jm = parcelRequire("7D2jm");
const $31fc0b63559b10c1$var$LoginPage = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $4Nxm2.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $6xwQE.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $h6Rwg.useSocialLogin)();
    const cobrandingApplication = (0, $NAfW5.useCobrandingApplication)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $91i6m.useState)(()=>emailFromSearchParams || "");
    (0, $6KORI.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === "mobile") onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: formatMessage((0, $9b70D.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
                pageId: (0, $1UkGo.pageId),
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4tmE5.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gx7I6.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $68WXR.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gKURT.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7Clnv.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $1UkGo.pageId),
                            onEmailChange: handleEmailChange,
                            showRememberMeCheckbox: rememberMeEnabled,
                            rememberMeChecked: isRememberMeChecked,
                            onToggleRememberMeCheckbox: onToggleRememberMeCheckbox
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $k3QGO.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
function $31fc0b63559b10c1$var$LoginRoute() {
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $4Nxm2.useLogin)();
    if (shouldShowRememberedAccounts) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7D2jm.default), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)($31fc0b63559b10c1$var$LoginPage, {});
}
var $31fc0b63559b10c1$export$2e2bcd8739ae039 = $31fc0b63559b10c1$var$LoginRoute;

});
parcelRegister("gKURT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4108e007ab21b5b$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $kLNLK = parcelRequire("kLNLK");

var $cLysE = parcelRequire("cLysE");

var $7cVVr = parcelRequire("7cVVr");

var $eECIq = parcelRequire("eECIq");

var $fHCVH = parcelRequire("fHCVH");

var $6jyTC = parcelRequire("6jyTC");

var $c9rdI = parcelRequire("c9rdI");

var $gtKO2 = parcelRequire("gtKO2");
const $c4108e007ab21b5b$var$SocialLoginBlock = (0, $fqDmW.default).div`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(0, $6e88g.gridSize)() * 1.5}px;

  border: 1px solid ${(0, $kLNLK.N50)};
  border-radius: 3px;
`;
const $c4108e007ab21b5b$var$Header = (0, $fqDmW.default).div`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${(0, $6e88g.gridSize)() * 1.5}px;
`;
const $c4108e007ab21b5b$var$Email = (0, $fqDmW.default).div`
  font-weight: 600;
  font-size: 14px;
  line-height: ${(0, $6e88g.gridSize)() * 3}px;
  color: ${(0, $kLNLK.N800)};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $c4108e007ab21b5b$var$Logo = (0, $fqDmW.default).img`
  height: ${(0, $6e88g.gridSize)() * 3}px;
  padding-right: ${(0, $6e88g.gridSize)()}px;
`;
const $c4108e007ab21b5b$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eECIq));
        case (0, $gtKO2.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fHCVH));
        case (0, $gtKO2.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6jyTC));
        case (0, $gtKO2.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($c9rdI));
    }
};
const $c4108e007ab21b5b$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $gtKO2.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $gtKO2.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $gtKO2.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $c4108e007ab21b5b$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $c4108e007ab21b5b$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Logo, {
                        src: $c4108e007ab21b5b$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    ...(0, $7cVVr.default).continueWith,
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                })
            })
        ]
    });
};
var $c4108e007ab21b5b$export$2e2bcd8739ae039 = $c4108e007ab21b5b$var$SocialLoginForm;

});
parcelRegister("7cVVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70b522f9e02cef9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b70b522f9e02cef9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    continueWith: {
        id: "social.login.form.continue-button",
        defaultMessage: "Continue with {socialProviderName}",
        description: "Button label that is a CTA for users to continue logging in using the selected social provider."
    }
});

});

parcelRegister("eECIq", function(module, exports) {
module.exports = new URL("google-logo.5867462c.svg", import.meta.url).toString();

});

parcelRegister("fHCVH", function(module, exports) {
module.exports = new URL("microsoft-logo.c73d8dca.svg", import.meta.url).toString();

});

parcelRegister("6jyTC", function(module, exports) {
module.exports = new URL("apple-logo.54e0d711.svg", import.meta.url).toString();

});

parcelRegister("c9rdI", function(module, exports) {
module.exports = new URL("slack-logo.5d730c10.svg", import.meta.url).toString();

});


parcelRegister("gx7I6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3609afe7f9a073$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8Bf3D = parcelRequire("8Bf3D");

var $bE8z6 = parcelRequire("bE8z6");

var $g6OTd = parcelRequire("g6OTd");

var $7eeh4 = parcelRequire("7eeh4");

var $1TbRW = parcelRequire("1TbRW");
const $cb3609afe7f9a073$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    if (isEmbedded) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1TbRW.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {})
            })
        ]
    });
};
var $cb3609afe7f9a073$export$2e2bcd8739ae039 = $cb3609afe7f9a073$var$Footer;

});
parcelRegister("8Bf3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8598e8620eefabcf$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");
const $8598e8620eefabcf$var$SeparatorContainer = (0, $fqDmW.default).li`
  margin: 0px 8px;

  + li {
    margin-top: 0px;
  }
`;
const $8598e8620eefabcf$var$Bull = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($8598e8620eefabcf$var$SeparatorContainer, {
        role: "presentation",
        children: "\u2022"
    });
var $8598e8620eefabcf$export$2e2bcd8739ae039 = $8598e8620eefabcf$var$Bull;

});


parcelRegister("4tmE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde66b37a92d3c19$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9b70D = parcelRequire("9b70D");

var $eaJyx = parcelRequire("eaJyx");
const $dde66b37a92d3c19$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $eaJyx.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            ...(0, $9b70D.LoginPageMessages).socialFormTitle,
            values: {
                socialProviderName: highlightedSocialProvider?.replace(/^./, (str)=>str.toUpperCase())
            }
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $eaJyx.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            ...(0, $9b70D.LoginPageMessages).headTitle
        })
    });
};
var $dde66b37a92d3c19$export$2e2bcd8739ae039 = $dde66b37a92d3c19$var$Header;

});

parcelRegister("k3QGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977fc0c59633125c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $j7UeI = parcelRequire("j7UeI");
const $977fc0c59633125c$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $977fc0c59633125c$export$2e2bcd8739ae039 = $977fc0c59633125c$var$MaybeSocialLoginPanel;

});
parcelRegister("j7UeI", function(module, exports) {

$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $6b71b168e012af76$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $6b71b168e012af76$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $fqDmW = parcelRequire("fqDmW");

var $6jyTC = parcelRequire("6jyTC");

var $eECIq = parcelRequire("eECIq");

var $fHCVH = parcelRequire("fHCVH");

var $c9rdI = parcelRequire("c9rdI");

var $ccxRw = parcelRequire("ccxRw");

var $ySUvx = parcelRequire("ySUvx");

var $cLysE = parcelRequire("cLysE");

var $8iEgn = parcelRequire("8iEgn");

var $cOOAJ = parcelRequire("cOOAJ");

var $9MKJ7 = parcelRequire("9MKJ7");

var $2UbF1 = parcelRequire("2UbF1");
const $6b71b168e012af76$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const googleOutageEnabled = (0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const microsoftOutageEnabled = (0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const appleOutageEnabled = (0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const slackOutageEnabled = (0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageTitle) : formatMessage((0, $ySUvx.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageDescription) : formatMessage((0, $ySUvx.default).someOutageDescription);
    const handleGoogleLoginOnClick = ()=>{
        handleGoogleLogin();
    };
    const GoogleButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($eECIq))),
                onClick: handleGoogleLoginOnClick,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).googleOutageDescription),
                children: "Google"
            })
        });
    const MicrosoftButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($fHCVH))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    const AppleButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6jyTC))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).appleOutageDescription),
                children: "Apple"
            })
        });
    const SlackButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c9rdI))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).slackOutageDescription),
                children: "Slack"
            })
        });
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$e61ba37bbdbb1966, {
        role: "list",
        "data-i18n-or": formatMessage((0, $ySUvx.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $ySUvx.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $6b71b168e012af76$export$e61ba37bbdbb1966 = (0, $fqDmW.default).ul`
  margin-top: ${(0, $6e88g.gridSize)() * 3}px;
  list-style: none;
  padding-inline: 0;
  margin-block-end: 0;
  &::before {
    color: ${(0, $kLNLK).N300};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${(0, $6e88g.gridSize)() * 2}px;
    font-weight: 600;
    text-align: center;
  }
`;
const $6b71b168e012af76$var$SocialLoginButtonRowGroup = (0, $fqDmW.default).div`
  &:not(:last-child) {
    margin-bottom: ${(0, $6e88g.gridSize)() * 2}px;
  }
`;
const $6b71b168e012af76$var$SocialLoginOptionWrapper = (0, $fqDmW.default).li`
  &:not(:last-child) {
    margin-bottom: ${(0, $6e88g.gridSize)() * 2}px;
  }
`;
const $6b71b168e012af76$var$SocialLoginButton = ({ children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage, ...props })=>{
    const commonProps = {
        isFullWidth: true,
        iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
            src: logo,
            alt: ""
        })
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9MKJ7.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, {
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $kLNLK).Y500,
                secondaryColor: (0, $kLNLK).Y50
            }),
            ...commonProps,
            ...props,
            children: children
        })
    });
    else return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, {
        advisoryEnabled: false,
        ...commonProps,
        ...props,
        children: children
    });
};
const $6b71b168e012af76$export$27110045cf7ea8db = (0, $fqDmW.default)((0, $cLysE.default), {
    shouldForwardProp: (propName)=>![
            "advisoryEnabled"
        ].includes(propName)
})`
  background: ${(props)=>props.advisoryEnabled ? (0, $kLNLK).Y50 : (0, $kLNLK).N0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${(0, $kLNLK).N50};
  border-radius: 3px;
  color: ${(0, $kLNLK).N800};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${(0, $6e88g.gridSize)() * 0.5}px;
  }

  &:hover {
    background: ${(0, $kLNLK).N10A} !important;
  }
  &:active {
    background: ${(0, $kLNLK).N20A} !important;
    color: ${(0, $kLNLK).N400} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`;
var $6b71b168e012af76$export$2e2bcd8739ae039 = $6b71b168e012af76$export$969af4902a13348e;

});
parcelRegister("ySUvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74db0f439e21255$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e74db0f439e21255$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    socialAuthContinue: {
        id: "social.auth.continue",
        defaultMessage: "Or continue with",
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: "some.outage.title",
        defaultMessage: "Issues with some login options",
        description: "Message to the user that there are currently issues logging in with some providers due to an outage"
    },
    googleOutageTitle: {
        id: "google.outage.title",
        defaultMessage: "Issues with Google login",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageTitle: {
        id: "microsoft.outage.title",
        defaultMessage: "Issues with Microsoft login",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageTitle: {
        id: "apple.outage.title",
        defaultMessage: "Issues with Apple login",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageTitle: {
        id: "slack.outage.title",
        defaultMessage: "Issues with Slack login",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    },
    someOutageDescription: {
        id: "some.outage.description",
        defaultMessage: "Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.",
        description: "Message to the user that there are currently issues logging in with due to a login provider outage"
    },
    googleOutageDescription: {
        id: "google.outage.description",
        defaultMessage: "There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageDescription: {
        id: "microsoft.outage.description",
        defaultMessage: "There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageDescription: {
        id: "apple.outage.description",
        defaultMessage: "There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageDescription: {
        id: "slack.outage.description",
        defaultMessage: "There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    }
});

});

parcelRegister("cOOAJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955165eea80d5a75$var$_react = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $955165eea80d5a75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $955165eea80d5a75$var$WarningIcon = (props)=>/*#__PURE__*/ $955165eea80d5a75$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$955165eea80d5a75$var$WarningIcon.displayName = "WarningIcon";
var $955165eea80d5a75$var$_default = $955165eea80d5a75$var$WarningIcon;
module.exports.default = $955165eea80d5a75$var$_default;

});



parcelRegister("68WXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef3e311772fd3c0$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $6d87w = parcelRequire("6d87w");

var $dBq8m = parcelRequire("dBq8m");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $8Bf3D = parcelRequire("8Bf3D");

var $64QTD = parcelRequire("64QTD");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");

var $9b70D = parcelRequire("9b70D");

var $1UkGo = parcelRequire("1UkGo");

var $6OnpU = parcelRequire("6OnpU");
const $1ef3e311772fd3c0$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const isCommercial = (0, $bqdjD.getCurrentPerimeter)() === "commercial";
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const signupLinkEnabled = (0, $91i6m.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== "true" && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    const getSignupLinkElement = ()=>{
        if (signupLinkEnabled) {
            const elementText = /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                ...(0, $9b70D.LoginPageMessages).createAnAccount
            });
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                to: "/signup" + location.search,
                id: "signup",
                className: "primary-action",
                onClick: ()=>{
                    analyticsClient.linkClickedEvent((0, $1UkGo.pageId), "signUpLink");
                },
                children: elementText
            });
        }
        return null;
    };
    const signupLink = getSignupLinkElement();
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $k8MAo.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            ...(0, $9b70D.LoginPageMessages).socialFormUseDifferentLoginMethod
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLink && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: signupLink
                    })
                ]
            })
        ]
    });
};
var $1ef3e311772fd3c0$export$2e2bcd8739ae039 = $1ef3e311772fd3c0$var$WhiteboxFooter;

});

parcelRegister("6KORI", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $0514ccbfce379500$export$84fc8ad34c97e462; });

var $91i6m = parcelRequire("91i6m");

var $h6aRF = parcelRequire("h6aRF");

var $fALlm = parcelRequire("fALlm");

var $NAfW5 = parcelRequire("NAfW5");
const $0514ccbfce379500$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $h6aRF.useRegisterComponent)($0514ccbfce379500$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    (0, $91i6m.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});

parcelRegister("7D2jm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255c740afd9c0353$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

const $255c740afd9c0353$var$BaseRememberedAccountsPage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("8Bo86")));
const $255c740afd9c0353$var$RememberedAccountsPage = ()=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($255c740afd9c0353$var$BaseRememberedAccountsPage, {});
};
var $255c740afd9c0353$export$2e2bcd8739ae039 = $255c740afd9c0353$var$RememberedAccountsPage;

});
parcelRegister("8Bo86", function(module, exports) {

var $2xbij = parcelRequire("2xbij");
module.exports = Promise.all([
    $2xbij("7tnr1"),
    $2xbij("6UgT0")
]).then(()=>parcelRequire("aAuK0"));

});



parcelRegister("15GiP", function(module, exports) {

$parcel$export(module.exports, "fontFallback", function () { return $0cb7128838712e24$export$2a99220fb32ec798; });
$parcel$export(module.exports, "headingSizes", function () { return $0cb7128838712e24$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $0cb7128838712e24$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $0cb7128838712e24$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $0cb7128838712e24$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $0cb7128838712e24$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $0cb7128838712e24$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $0cb7128838712e24$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $0cb7128838712e24$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $0cb7128838712e24$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $0cb7128838712e24$export$dfc0e69214efdc3c; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");

var $6e88g = parcelRequire("6e88g");
function $0cb7128838712e24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0cb7128838712e24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0cb7128838712e24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0cb7128838712e24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0cb7128838712e24$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $0cb7128838712e24$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $0cb7128838712e24$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $0cb7128838712e24$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h900.size, $0cb7128838712e24$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 6.5, "px")
    });
};
var $0cb7128838712e24$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h800.size, $0cb7128838712e24$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h700.size, $0cb7128838712e24$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h600.size, $0cb7128838712e24$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3.5, "px")
    });
};
var $0cb7128838712e24$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h500.size, $0cb7128838712e24$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3, "px")
    });
};
var $0cb7128838712e24$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h400.size, $0cb7128838712e24$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h300.size, $0cb7128838712e24$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $0cb7128838712e24$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h200.size, $0cb7128838712e24$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h100.size, $0cb7128838712e24$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};

});

parcelRegister("6Xy2r", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $5112a8195f7745b7$export$e0be378c32fb70a7; });

var $91i6m = parcelRequire("91i6m");

var $2A9c9 = parcelRequire("2A9c9");

var $8z7c3 = parcelRequire("8z7c3");

var $ippcL = parcelRequire("ippcL");
function $5112a8195f7745b7$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $91i6m.useContext((0, $8z7c3.ManagerReferenceNodeSetterContext));
    var refHandler = $91i6m.useCallback(function(node) {
        (0, $ippcL.setRef)(innerRef, node);
        (0, $ippcL.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $91i6m.useEffect(function() {
        return function() {
            return (0, $ippcL.setRef)(innerRef, null);
        };
    }, []);
    $91i6m.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($2A9c9)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $ippcL.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("2A9c9", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1e16137e251b5c4c$var$__DEV__ = false;
var $1e16137e251b5c4c$var$warning = function() {};
if ($1e16137e251b5c4c$var$__DEV__) {
    var $1e16137e251b5c4c$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $1e16137e251b5c4c$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $1e16137e251b5c4c$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $1e16137e251b5c4c$var$warning;

});


parcelRegister("h89s9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666bf2328d96f7b9$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $7ecAu = parcelRequire("7ecAu");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");

var $TJrLs = parcelRequire("TJrLs");

var $k8ZoM = parcelRequire("k8ZoM");
// override the text field border to avoid nested borders when using elemAfterInputExternal
const $666bf2328d96f7b9$var$BorderOverride = (0, $fqDmW.default).div`
  border: 1px solid ${(0, $k8ZoM.default)("color.border.input")};
  border-radius: 4px;

  * {
    border: none !important; // important styles needed for Safari
  }
`;
// required because currently the Atlaskit elemAfterInput does not support nesting focus correctly.
// once https://product-fabric.atlassian.net/browse/DSP-14006 has been resolved, we should be able to remove this code.
const $666bf2328d96f7b9$var$MaybeCustomBorder = ({ useCustomBordering: useCustomBordering, children: children })=>{
    if (useCustomBordering) return /*#__PURE__*/ (0, $4ZSso.jsx)($666bf2328d96f7b9$var$BorderOverride, {
        children: children
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
const $666bf2328d96f7b9$var$FormTextField = ({ name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, elemAfterInputExternal: elemAfterInputExternal, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($666bf2328d96f7b9$var$MaybeCustomBorder, {
                        useCustomBordering: !!elemAfterInputExternal,
                        children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $TJrLs.default), {
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), {
                                    ...fieldProps,
                                    ...props,
                                    testId: testId,
                                    ref: ref
                                }),
                                elemAfterInputExternal
                            ]
                        })
                    }),
                    invalidMessage && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                        children: invalidMessage
                    })
                ]
            })
    });
};
var $666bf2328d96f7b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($666bf2328d96f7b9$var$FormTextField);

});
parcelRegister("9yEtj", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $6f56aedca101884d$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $lPOF7 = parcelRequire("lPOF7");

var $6m0jT = parcelRequire("6m0jT");

var $daZRO = parcelRequire("daZRO");

var $kLNLK = parcelRequire("kLNLK");

var $kROoV = parcelRequire("kROoV");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $6f56aedca101884d$var$messageStyles = (0, $lPOF7.css)({
    display: "flex",
    justifyContent: "baseline",
    gap: "var(--ds-space-050, 4px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    marginBlockStart: "var(--ds-space-050, 4px)"
});
var $6f56aedca101884d$var$messageAppearanceStyles = {
    default: (0, $lPOF7.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")")
    }),
    error: (0, $lPOF7.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $lPOF7.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $6f56aedca101884d$var$iconWrapperStyles = (0, $lPOF7.css)({
    display: "flex"
});
var $6f56aedca101884d$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $lPOF7.jsx)("span", {
        css: $6f56aedca101884d$var$iconWrapperStyles
    }, children);
};
var $6f56aedca101884d$var$messageIcons = {
    error: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($daZRO))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6m0jT))), {
        size: "small",
        label: "success"
    })
};
var $6f56aedca101884d$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $6f56aedca101884d$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $lPOF7.jsx)("span", null, children);
    return (0, $lPOF7.jsx)("div", {
        css: [
            $6f56aedca101884d$var$messageStyles,
            $6f56aedca101884d$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $lPOF7.jsx)($6f56aedca101884d$var$IconWrapper, null, icon), content);
};
var $6f56aedca101884d$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("6m0jT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a050babc32300d7$var$_react = $4a050babc32300d7$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4a050babc32300d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a050babc32300d7$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4a050babc32300d7$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$4a050babc32300d7$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $4a050babc32300d7$var$_default = $4a050babc32300d7$var$EditorSuccessIcon;
module.exports.default = $4a050babc32300d7$var$_default;

});



parcelRegister("dSVKJ", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $a1bd1dfd7b12d44d$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "UNSAFE_media", function () { return $a1bd1dfd7b12d44d$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $a1bd1dfd7b12d44d$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $a1bd1dfd7b12d44d$export$c881183ca713c214 = $a1bd1dfd7b12d44d$export$987d49ffe1b0900f;

});

parcelRegister("gFwNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439af55d1343b8c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");
const $1439af55d1343b8c$var$FieldGroupStyled = (0, $fqDmW.default).div`
  margin-top: ${(0, $6e88g.gridSize)()}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${-(0, $6e88g.gridSize)()}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`;
function $1439af55d1343b8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)($1439af55d1343b8c$var$FieldGroupStyled, {
        ...props,
        className: `${props.className ? props.className : ""} ${props.isHidden ? "hidden" : ""}`
    });
}

});

parcelRegister("fFuU3", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $b682a811178c7b2e$export$badac9ada3a0bdf9; });

var $iqLBO = parcelRequire("iqLBO");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $blZ6m = parcelRequire("blZ6m");

var $9vpSS = parcelRequire("9vpSS");

// Export types from PopperJS / React Popper
var $b682a811178c7b2e$var$viewportPadding = 5;
var $b682a811178c7b2e$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $b682a811178c7b2e$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $b682a811178c7b2e$var$defaultChildrenFn() {
    return null;
}
var $b682a811178c7b2e$var$defaultOffset = [
    0,
    8
];
function $b682a811178c7b2e$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $b682a811178c7b2e$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $b682a811178c7b2e$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $91i6m.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $b682a811178c7b2e$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $9vpSS.getMaxSizeModifiers)({
            viewportPadding: $b682a811178c7b2e$var$viewportPadding
        }) : [];
        return [].concat($b682a811178c7b2e$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $91i6m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $blZ6m.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("9vpSS", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $6ebb165987d41554$export$6d8c2b45c99d6e3f; });

var $5YM7L = parcelRequire("5YM7L");
function $6ebb165987d41554$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("c1txK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d35d6bdef48785fd$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $h89s9 = parcelRequire("h89s9");

var $fqDmW = parcelRequire("fqDmW");

var $6yJnE = parcelRequire("6yJnE");

var $gB4dU = parcelRequire("gB4dU");

var $tbh94 = parcelRequire("tbh94");

var $leG06 = parcelRequire("leG06");
const $d35d6bdef48785fd$export$d25f95f50a0dfdf9 = (0, $fqDmW.default).div`
  padding: 3px;
  margin-left: -1px;
`;
const $d35d6bdef48785fd$var$StyledDiv = (0, $fqDmW.default).div`
  input {
    ${(props)=>props.smallPlaceholder && "font-size: 14px !important;"}
  }
`;
const $d35d6bdef48785fd$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $91i6m.useRef)(null);
    const [type, setType] = (0, $91i6m.useState)("password");
    (0, $91i6m.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        setType(type === "password" ? "text" : "password");
        inputRef.current?.focus();
    };
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$var$StyledDiv, {
            smallPlaceholder: props.smallPlaceholder,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                ...props,
                type: type,
                autoComplete: type === "password" ? props.autoComplete || "off" : "off",
                spellCheck: false,
                ref: inputRef,
                elemAfterInputExternal: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$export$d25f95f50a0dfdf9, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $tbh94.default), {
                        appearance: "subtle",
                        icon: type === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($gB4dU))) : (0, (/*@__PURE__*/$parcel$interopDefault($6yJnE))),
                        label: type === "text" ? formatMessage({
                            id: "password.field.password.hide",
                            defaultMessage: "Hide password"
                        }) : formatMessage({
                            id: "password.field.password.show",
                            defaultMessage: "Show password"
                        }),
                        onClick: handleVisibilityToggle
                    })
                })
            })
        })
    });
};
var $d35d6bdef48785fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($d35d6bdef48785fd$var$PasswordField);

});
parcelRegister("6yJnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c691eb080b990e3$var$_react = $4c691eb080b990e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4c691eb080b990e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4c691eb080b990e3$var$WatchIcon = (props)=>/*#__PURE__*/ $4c691eb080b990e3$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.977 13.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4"/></g></svg>`
    }, props));
$4c691eb080b990e3$var$WatchIcon.displayName = "WatchIcon";
var $4c691eb080b990e3$var$_default = $4c691eb080b990e3$var$WatchIcon;
module.exports.default = $4c691eb080b990e3$var$_default;

});

parcelRegister("gB4dU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c15360b5fe5850fb$var$_react = $c15360b5fe5850fb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $c15360b5fe5850fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c15360b5fe5850fb$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $c15360b5fe5850fb$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 01-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 014.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$c15360b5fe5850fb$var$WatchFilledIcon.displayName = "WatchFilledIcon";
var $c15360b5fe5850fb$var$_default = $c15360b5fe5850fb$var$WatchFilledIcon;
module.exports.default = $c15360b5fe5850fb$var$_default;

});

parcelRegister("tbh94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057b74a26f2e932f$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $jFzn9 = parcelRequire("jFzn9");

var $hbHfz = parcelRequire("hbHfz");
var $057b74a26f2e932f$var$_excluded = [
    "analyticsContext",
    "interactionName",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "icon",
    "label",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "shape",
    "type",
    "testId",
    "UNSAFE_size",
    "aria-label"
];
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $057b74a26f2e932f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, icon = _ref.icon, label = _ref.label, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, shape = _ref.shape, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, UNSAFE_size = _ref.UNSAFE_size, preventedAriaLabel = _ref["aria-label"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $057b74a26f2e932f$var$_excluded);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $hbHfz.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jFzn9.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$057b74a26f2e932f$var$IconButton.displayName = "IconButton";
var $057b74a26f2e932f$export$2e2bcd8739ae039 = $057b74a26f2e932f$var$IconButton;

});
parcelRegister("jFzn9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e51d48da70b110fd$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $iqLBO = parcelRequire("iqLBO");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $l6Ab5 = parcelRequire("l6Ab5");

var $4QcjI = parcelRequire("4QcjI");

var $8YrnH = parcelRequire("8YrnH");

var $lqweQ = parcelRequire("lqweQ");

var $ky0rp = parcelRequire("ky0rp");
var $e51d48da70b110fd$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $e51d48da70b110fd$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $e51d48da70b110fd$var$focusRingStyles = (0, $lqweQ.xcss)({
    ":focus-visible": $e51d48da70b110fd$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $e51d48da70b110fd$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $e51d48da70b110fd$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4QcjI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $e51d48da70b110fd$var$_excluded);
    var interactionContext = (0, $91i6m.useContext)((0, $8YrnH.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $l6Ab5.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "3.2.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $lqweQ.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $e51d48da70b110fd$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ky0rp.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $e51d48da70b110fd$export$2e2bcd8739ae039 = $e51d48da70b110fd$var$UNSAFE_PRESSABLE;

});

parcelRegister("hbHfz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8350358a3b7f001$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kQU6o = parcelRequire("kQU6o");

var $fXpPO = parcelRequire("fXpPO");

var $6U7Fi = parcelRequire("6U7Fi");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $c8350358a3b7f001$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay);
    var isCircle = shape === "circle";
    var baseProps = (0, $6U7Fi.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
            label: "",
            size: UNSAFE_size
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $c8350358a3b7f001$export$2e2bcd8739ae039 = $c8350358a3b7f001$var$useIconButton;

});



parcelRegister("31nHY", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $807125d1ec365411$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $807125d1ec365411$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $807125d1ec365411$export$1142f7f46d50535e; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $8iEgn = parcelRequire("8iEgn");
const $807125d1ec365411$export$21ea266f0fa7d7c3 = (0, $fqDmW.default).div`
  margin-bottom: ${(0, $6e88g.gridSize)() * 2}px;
`;
const $807125d1ec365411$var$SectionErrorWrapper = (0, $fqDmW.default).div`
  margin-top: ${(0, $6e88g.gridSize)()}px;
  margin-bottom: ${(0, $6e88g.gridSize)()}px;
`;
function $807125d1ec365411$export$2e2bcd8739ae039({ testId: testId, title: title, children: children, appearance: appearance = "warning" }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$export$21ea266f0fa7d7c3, {
        role: "alert",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: appearance,
            title: title,
            children: children
        })
    }) : null;
}
function $807125d1ec365411$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("brCu8", function(module, exports) {

$parcel$export(module.exports, "useTranslateFormErrorIfAvailable", function () { return $9c7488dbc3e314ea$export$61b698e3c147347c; });

var $j5RJC = parcelRequire("j5RJC");
var $leG06 = parcelRequire("leG06");

var $91i6m = parcelRequire("91i6m");
const $9c7488dbc3e314ea$export$61b698e3c147347c = (formError)=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const message = (0, $91i6m.useMemo)(()=>Object.values($9c7488dbc3e314ea$var$formValidationMessages).find(({ id: id })=>id === formError), [
        formError
    ]);
    if (message) return formatMessage(message);
    else return formError;
};
const $9c7488dbc3e314ea$var$formValidationMessages = (0, $j5RJC.defineMessages)({
    unknownError: {
        id: "com.atlassian.profile.unknownError",
        defaultMessage: "An unknown error occurred"
    },
    errorRequiredField: {
        id: "error.required",
        defaultMessage: "This field is required"
    },
    loginFormNoPassword: {
        id: "login.form.no.password",
        defaultMessage: "Enter your password"
    },
    loginFormPasswordTooLong: {
        id: "login.form.password.too.long",
        defaultMessage: "Password length capped at 100 characters"
    },
    loginFormPasswordTooShort: {
        id: "login.form.password.too.short",
        defaultMessage: "The password is too short."
    },
    resetPasswordGenericError: {
        id: "resetPassword.error",
        defaultMessage: "An error occurred while attempting to reset your password."
    },
    resetPasswordEmailFormatError: {
        id: "requestPasswordReset.email.format.error",
        defaultMessage: "Please enter a valid email address"
    },
    signupDisplayNameEmpty: {
        id: "signup.display.name.empty",
        defaultMessage: "Full name must not be empty"
    },
    signupDisplayNameTooLong: {
        id: "signup.display.name.too.long",
        defaultMessage: "Full name must not be greater than 255 characters"
    },
    signupEmailFormatError: {
        id: "signup.email.format.error",
        defaultMessage: "Email is required to be in correct format"
    },
    signupEmailReachedMaxAliases: {
        id: "signup.email.reached.max.aliases",
        defaultMessage: "Email aliases are rate limited"
    },
    signupEmailRestrictedDomain: {
        id: "signup.email.restricted.domain.error",
        defaultMessage: "The provided email address is not allowed, please use a different one"
    },
    signupGenericFailure: {
        id: "signup.failure",
        defaultMessage: "We are unable to sign you up. Please contact support."
    },
    signupCaptchaResponseError: {
        id: "signup.captcha.response.required.error",
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});

parcelRegister("jthWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97147eacdc47bb45$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $97147eacdc47bb45$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    unexpectedErrorHappened: {
        id: "login.form.sso.check.unknown.error",
        defaultMessage: "Unexpected error happened.",
        description: ""
    },
    emailPlaceholder: {
        id: "login.form.email.placeholder",
        defaultMessage: "Enter your email"
    },
    emailEmpty: {
        id: "login.form.email.empty",
        defaultMessage: "Enter an email address"
    },
    passwordEmpty: {
        id: "login.form.password.empty",
        defaultMessage: "Enter your password"
    },
    migrateAccountInfo: {
        id: "login.form.info.migrate.account",
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: "Login form info container message"
    },
    existingUserSignupAttemptInfo: {
        id: "login.form.info.existing.user.signup.attempt",
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: "Login form info container message for existing user signup attempt"
    },
    rateLimitErrorMessage: {
        id: "login.form.email.rate-limit-exceeded.error",
        defaultMessage: "There have been too many attempts to reverify your account in the past hour. Please try again later.",
        description: "Telling the user that they have exceeded welcome email limit"
    },
    rememberMeCheckboxLabel: {
        id: "login.form.remember.me.checkbox.label",
        defaultMessage: "Remember me",
        description: "Label for the checkbox that will enable the behaviour to remember a user's account on this device"
    },
    rememberMeMoreInfoLabel: {
        id: "login.form.remember.me.moreinfo.label",
        defaultMessage: "More info about Remember Me.",
        description: "Label for info icon that describes what Remember Me is"
    },
    rememberMeTooltip: {
        id: "login.form.remember.me.tooltip",
        defaultMessage: "We remember your account information for the next time you log in.",
        description: "Tooltip content for the remember me checkbox"
    }
});

});

parcelRegister("cJRdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordPlaceholder: {
        id: "login.form.password.placeholder",
        defaultMessage: "Enter password"
    },
    passwordLabel: {
        id: "login.form.password.label",
        defaultMessage: "Password"
    }
});

});

parcelRegister("gaHKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb38136af8a7975$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $dcb38136af8a7975$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: "login.form.username.placeholder",
        defaultMessage: "Enter email"
    },
    loginFormUsernameLabel: {
        id: "login.form.username.label",
        defaultMessage: "Email"
    },
    loginFormReadOnlyUsernameAriaLabel: {
        id: "login.form.readonly.username.aria.label",
        defaultMessage: "Edit email"
    }
});

});

parcelRegister("bt1Sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8593db29877e5ae9$var$_react = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $8593db29877e5ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8593db29877e5ae9$var$EmailIcon = (props)=>/*#__PURE__*/ $8593db29877e5ae9$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$8593db29877e5ae9$var$EmailIcon.displayName = "EmailIcon";
var $8593db29877e5ae9$var$_default = $8593db29877e5ae9$var$EmailIcon;
module.exports.default = $8593db29877e5ae9$var$_default;

});

parcelRegister("9w0eB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319ab9a4a7a53ac$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cJRdM = parcelRequire("cJRdM");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");
const $b319ab9a4a7a53ac$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const inputRef = (0, $91i6m.useRef)(null);
    const wasHidden = (0, $0wXBc.usePrevious)(isHidden);
    (0, $91i6m.useEffect)(()=>{
        if (!isHidden && wasHidden) inputRef.current?.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError ? /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
        id: "password-error",
        children: fieldError
    }) : fieldError;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $cJRdM.default).passwordPlaceholder),
            label: formatMessage((0, $cJRdM.default).passwordLabel),
            autoFocus: !isHidden,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef
        })
    });
};
var $b319ab9a4a7a53ac$export$2e2bcd8739ae039 = $b319ab9a4a7a53ac$var$PasswordContainer;

});

parcelRegister("lnbpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c71a1682cc4a680$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
const $5c71a1682cc4a680$var$FormInfo = (0, $fqDmW.default).div`
  color: ${(0, $kLNLK).N700};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${(0, $6e88g.gridSize)() * 2}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`;
const $5c71a1682cc4a680$var$FormInfoComponent = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($5c71a1682cc4a680$var$FormInfo, {
        role: "alert",
        ...props,
        className: props.isHidden ? "hidden" : "",
        children: children
    });
};
var $5c71a1682cc4a680$export$2e2bcd8739ae039 = $5c71a1682cc4a680$var$FormInfoComponent;

});


//# sourceMappingURL=BasePage.b025bd17.js.map
